import axiosInstance from '../axios.instance';

// eslint-disable-next-line import/prefer-default-export
export const getUserBalancesApi = (token) => axiosInstance.get('/user/balances', {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getBillingDataApi = (token, id) => axiosInstance.get(`/operation/deposit/${id}`, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getTokensListApi = (token, searchValue = '', page = 1) => axiosInstance.get(`/operation/withdraw?page=${page}${searchValue ? '&q=' + searchValue : ''}`, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getWithdrawApi = (token, data) => axiosInstance.post('/operation/withdraw/send', data, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const confirmWithdrawApi = (token, id, code) => axiosInstance.post(`/operation/withdraw/confirm/${id}`, {code}, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getTransactionsHistoryApi = (token) => axiosInstance.get('/transaction/transactions', {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});
